import React, { useCallback } from 'react';
import _get from 'lodash/get';

import { UiKit } from 'components';
import Content from './Content';
import { useMutation } from 'utils/hooks';

export default function DeleteExceptionModal({
  apiKey = '',
  isOpen = false,
  data = null,
  onClose = () => {},
  onClosed = () => {},
  successCallback = () => {},
  errorCallback = () => {}
}) {
  if (!apiKey) {
    throw new Error(
      '"apiKey" is required in <DeleteExceptionModal/> component'
    );
  }

  const id = _get(data, 'id', '');

  const isModalOpen = isOpen && !!id;

  const { mutate: onConfirm, isProcessing } = useMutation(apiKey, 'DELETE', {
    routeParam: id,
    successMessage: 'Successfully deleted the exception',
    errorMessage:
      'Unable to delete the exception at the moment. Please try again later.',
    onSuccess: useCallback(() => successCallback(), [successCallback]),
    onError: useCallback(() => errorCallback(), [errorCallback]),
    onFinally: useCallback(() => onClose(), [onClose])
  });

  if (!id) return null;

  return (
    <UiKit.Modal
      isOpen={isModalOpen}
      onClose={onClose}
      onClosed={onClosed}
      isProcessing={isProcessing}
    >
      <UiKit.Modal.Header title="Delete Exception" />
      <UiKit.Modal.Body>
        <Content data={data} />
      </UiKit.Modal.Body>
      <UiKit.Modal.Footer
        onConfirm={() => onConfirm()}
        confirmBtnVariant="destructive"
        confirmBtnText="Confirm"
      />
    </UiKit.Modal>
  );
}
